module.exports = __webpack_public_path__ + "img/library-cta-back.2dc1add7.svg";